@import "src/styles/PrimaryActionMixins.scss";

:host {
  display: flex;
  flex: 1 1 auto;
  width: 100%;
  min-height: 0;
  min-width: 0;
}

.twoStepCardFlow,
.twoStepCardFlowCardStep,
.twoStepCardFlowStoreStep {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  width: 100%;
  min-height: 0;
  min-width: 0;
}

.twoStepCardFlow {
  height: 100%;
}

.twoStepCardFlowStoreStep > store-card {
  display: flex;
  flex: 1 1 auto;
  width: 100%;
  height: 100%;
  min-height: 0;
  min-width: 0;
}

.twoStepCardFlowCardStep[hidden],
.twoStepCardFlowStoreStep[hidden] {
  display: none;
}

.twoStepCardFlowScrollableContent {
  box-sizing: border-box;
  flex: 1 1 auto;
  width: 100%;
  min-height: 0;
  min-width: 0;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  padding: 0 8px 0 2px;
  scrollbar-color: #c5c5ca transparent;
  scrollbar-gutter: stable;
  scrollbar-width: thin;
}

.twoStepCardFlowScrollableContent::-webkit-scrollbar {
  width: 6px;
}

.twoStepCardFlowScrollableContent::-webkit-scrollbar-thumb {
  background-color: #c5c5ca;
  border-radius: 6px;
}

.twoStepCardFlowScrollableContent::-webkit-scrollbar-track {
  background: transparent;
}

.twoStepCardFlowMessage {
  display: block;
  margin-bottom: 24px;
}

.twoStepCardFlowCardIframe {
  border: 0;
  min-height: 230px;
  width: 100%;
}

.twoStepCardFlowConsent {
  width: 100%;
}

.twoStepCardFlowConsent > consent-checkbox {
  display: block;
}

.twoStepCardFlowConsentWarning {
  display: grid;
  grid-template-columns: auto 1fr;
  column-gap: 7px;
  color: #ef2039;
  margin: 10px 0 0 45px;
  font-size: 12px;
  font-weight: 400;
  line-height: 140%;
}

.twoStepCardFlowConsentWarningIcon {
  margin-top: 3px;
}

.twoStepCardFlowActions {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 0 0 max(40px, env(safe-area-inset-bottom)) 4px;
  background: #ffffff;
}

.twoStepCardFlowContinue {
  @include softDisabledPrimaryAction();

  box-sizing: border-box;
  align-self: center;
  margin: 18px 0 0;
  width: 376px;
  max-width: 100%;
  height: 48px;
  padding: 0;
  border: 0;
  border-radius: 24px;
  background: #16182b;
  color: #ffffff;
  font-family: "Inter";
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  cursor: pointer;
}

.twoStepCardFlowContinue:focus-visible {
  outline: 2px solid #4d5ef2;
  outline-offset: 2px;
}

.twoStepCardFlowContinue:disabled {
  cursor: not-allowed;
}

.twoStepCardFlowSecondaryAction {
  display: flex;
  align-items: center;
  justify-content: center;
}

.payairPaymentSheetOverlay two-step-card-flow,
.payairPaymentSheetOverlay .twoStepCardFlow,
.payairPaymentSheetOverlay .twoStepCardFlowCardStep,
.payairPaymentSheetOverlay .twoStepCardFlowStoreStep,
.payairPaymentSheetOverlay .twoStepCardFlowStoreStep > store-card {
  flex: 0 0 auto;
  height: auto;
}

.payairPaymentSheetOverlay .twoStepCardFlowScrollableContent {
  flex: 0 0 auto;
  overflow: visible;
  padding-right: 2px;
  scrollbar-gutter: auto;
}

@media (max-width: 540px) and (max-height: 700px) {
  .twoStepCardFlowActions {
    padding-bottom: max(24px, env(safe-area-inset-bottom));
  }
}
